import { render, staticRenderFns } from "./DfExam.vue?vue&type=template&id=4ea67306&"
import script from "./DfExam.vue?vue&type=script&lang=js&"
export * from "./DfExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports